// DOM 取得の唯一の入口。index.html に必ず存在する要素だけを引くので、
// 見つからないのはマークアップの破壊であり、握りつぶさず即座に落とす。
// 非 null アサーション（!）はここに閉じ込め、呼び出し側には現れないようにする。
export function $<T extends Element>(selector: string, root: ParentNode = document): T {
  const el = root.querySelector<T>(selector);
  if (!el) throw new Error(`要素が見つかりません: ${selector}`);
  return el;
}

/** クリック対象から、data 属性を持つ最も近い祖先ボタンを引く。イベント委譲の共通処理。 */
export function closestAction(target: EventTarget | null, attr: string): HTMLElement | null {
  if (!(target instanceof Element)) return null;
  return target.closest<HTMLElement>(`[${attr}]`);
}
